import {SmppConnectionState} from "@/store/settings/smpp_connections/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: SmppConnectionState = {
  smppConnections: [],
  serverNames: [],
}

export const smppConnections: Module<SmppConnectionState, RootState> = {
  state,
  getters,
  actions,
  mutations
}